export default __webpack_public_path__ + "static/media/bed_icon.d8b98342.svg";